import { render, staticRenderFns } from "./TipoviObjekata.vue?vue&type=template&id=679bd703&scoped=true&"
import script from "./TipoviObjekata.vue?vue&type=script&lang=ts&"
export * from "./TipoviObjekata.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679bd703",
  null
  
)

export default component.exports